import {
  DataRealTimeDTO,
  RealTimeMessageDto,
} from "../../shared/DTO/RealTimeMessageDTO";

export class DataRealTime {
  constructor(
    public localId: string,
    public stateVariables: Map<string, any>
  ) {}
}

export class RealTimeMessage {
  constructor(
    public messageType: string,
    public operationType: string,
    public data: DataRealTime
  ) {}

  static fromDTO(
    messageType: string,
    operationType: string,
    dataRealTimeDTO: DataRealTimeDTO
  ) {
    const { localId, stateVariables } = dataRealTimeDTO;

    const data = new DataRealTime(localId, stateVariables);

    return new RealTimeMessage(messageType, operationType, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/real-time-message.model.ts